exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:100);", ""]);

// module
exports.push([module.id, ".tick-tock-time {\n  font-size: 2em;\n  font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/tick-tock/tick-tock.component.scss
// module id = 16
// module chunks = 0 1